import { createElement } from 'react';
import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { isStackEntity, stackSupports } from '@internal/plugin-stack-common';
import { showsLogSourcesTab } from './logSources/logSourcesTab';

const stackDetailsTab = EntityContentBlueprint.make({
  name: 'stack-details',
  params: {
    path: '/',
    title: 'Details',
    filter: isStackEntity,
    loader: () =>
      import('./components/StackEntityDetailsPage').then(m =>
        createElement(m.StackEntityDetailsPage),
      ),
  },
});

const stackGraphTab = EntityContentBlueprint.make({
  name: 'stack-graph',
  params: {
    path: '/graph',
    title: 'Resource Graph',
    // A single address or image has one node and no edges, so the graph shows
    // the page's own title in a box.
    filter: entity => stackSupports(entity, 'graph'),
    loader: () =>
      import('./components/StackGraphPage').then(m =>
        createElement(m.StackGraphPage),
      ),
  },
});

const stackLogSourcesTab = EntityContentBlueprint.make({
  name: 'stack-log-sources',
  params: {
    path: '/log-sources',
    title: 'Log Sources',
    filter: showsLogSourcesTab,
    loader: () =>
      import('./logSources/LogSourcesPage').then(m =>
        createElement(m.LogSourcesPage),
      ),
  },
});

const applicationGroupOverviewTab = EntityContentBlueprint.make({
  name: 'application-group-overview',
  params: {
    path: '/',
    title: 'Overview',
    filter: entity =>
      entity.apiVersion === 'aeven.io/v1alpha1' &&
      entity.kind === 'ApplicationGroup',
    loader: () =>
      import('./components/ApplicationGroupOverviewPage').then(m =>
        createElement(m.ApplicationGroupOverviewPage),
      ),
  },
});

const applicationGroupAccessTab = EntityContentBlueprint.make({
  name: 'application-group-access',
  params: {
    path: '/access',
    title: 'Access',
    filter: entity =>
      entity.apiVersion === 'aeven.io/v1alpha1' &&
      entity.kind === 'ApplicationGroup',
    loader: () =>
      import('./components/ApplicationGroupAccessPage').then(m =>
        createElement(m.ApplicationGroupAccessPage),
      ),
  },
});

export const stackEntityPlugin = createFrontendPlugin({
  pluginId: 'stack-entity',
  extensions: [
    stackDetailsTab,
    stackGraphTab,
    stackLogSourcesTab,
    applicationGroupOverviewTab,
    applicationGroupAccessTab,
  ],
});
